import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const InfoIconDark: React.FC<IconSvgProps> = (props) => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle
      cx="26"
      cy="26"
      r="16"
      fill="url(#paint0_radial_33361_635908)"
      stroke="url(#paint1_radial_33361_635908)"
      strokeWidth="3"
    />
    <rect
      width="12.3077"
      height="1.84328"
      rx="0.921638"
      transform="matrix(-4.37114e-08 1 1 4.37114e-08 25.0784 22.858)"
      fill="white"
    />
    <rect
      width="3"
      height="1.84328"
      rx="0.921638"
      transform="matrix(-4.37114e-08 1 1 4.37114e-08 25.0784 16.8343)"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_33361_635908"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.2937 13.2503) rotate(56.425) scale(36.3071)"
      >
        <stop offset="0.62" stopColor="#8373F9" />
        <stop offset="0.62" stopColor="#6450F7" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_33361_635908"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.6381 16.2168) rotate(48.633) scale(32.8477)"
      >
        <stop offset="0.62" stopColor="white" />
        <stop offset="0.63" stopColor="#D1D1D1" />
      </radialGradient>
    </defs>
  </svg>
)

export const InfoIconLight: React.FC<IconSvgProps> = (props) => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle
      cx="26"
      cy="26"
      r="16"
      fill="url(#paint0_radial_33361_635899)"
      stroke="url(#paint1_radial_33361_635899)"
      strokeWidth="3"
    />
    <rect
      width="12.3077"
      height="1.84328"
      rx="0.921638"
      transform="matrix(-4.37114e-08 1 1 4.37114e-08 25.0783 22.858)"
      fill="#133C40"
    />
    <rect
      width="3"
      height="1.84328"
      rx="0.921638"
      transform="matrix(-4.37114e-08 1 1 4.37114e-08 25.0783 16.8343)"
      fill="#133C40"
    />
    <defs>
      <radialGradient
        id="paint0_radial_33361_635899"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.2937 13.2503) rotate(56.425) scale(36.3071)"
      >
        <stop offset="0.62" stopColor="#DDF247" />
        <stop offset="0.62" stopColor="#B0D717" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_33361_635899"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.6381 16.2168) rotate(48.633) scale(32.8477)"
      >
        <stop offset="0.62" stopColor="#4A7875" />
        <stop offset="0.63" stopColor="#133C40" />
      </radialGradient>
    </defs>
  </svg>
)

export function InfoIconCoachLight(props: IconSvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" {...props}>
      <circle
        cx="26"
        cy="26"
        r="16"
        fill="url(#paint0_radial_3085_4821)"
        stroke="url(#paint1_radial_3085_4821)"
        strokeWidth="3"
      />
      <rect
        width="12.3077"
        height="1.84328"
        rx="0.921638"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 25.0781 22.8574)"
        fill="#6450F7"
      />
      <rect
        width="3"
        height="1.84328"
        rx="0.921638"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 25.0781 16.834)"
        fill="#6450F7"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3085_4821"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.2937 13.2503) rotate(56.425) scale(36.3071)"
        >
          <stop offset="0.62" stopColor="white" />
          <stop offset="0.62" stopColor="#E6E6E6" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3085_4821"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.6381 16.2168) rotate(48.633) scale(32.8477)"
        >
          <stop offset="0.62" stopColor="#8373F9" />
          <stop offset="0.63" stopColor="#6450F7" />
        </radialGradient>
      </defs>
    </svg>
  )
}
